import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './ArrivalConfirmationButtons.css';
import Btn from '../../../component/button/btn/Btn';
import EyeHideSection from '../../components/eyeHideSection/EyeHideSection';
import {BLACK, WHITE, YELLOW} from '../../../globalVariables/GlobalVariables';

const style = ` height: 40px;
                width: 150px;
                line-height:40px;
                font-size: 14px;
                padding-inline-end:27px;
                background-color: ${WHITE};
                border-color: ${BLACK};
               `;

function ArrivalConfirmationButtons() {
    const {t} = useTranslation('suspendedConfirmation');

    const wrapper=(sectionName,children)=>
        <EyeHideSection sectionName={sectionName}>{children}</EyeHideSection>;

    return (   
        <css.wrapper data-cy='ArrivalConfirmationButtons'>
            {wrapper('WillCome',<Btn style={style+` background-color:${YELLOW};border:none;`}>{t('WillCome')}</Btn>)}
            {wrapper('maybe', <Btn style={style}>{t('maybe')}</Btn>)}
            {wrapper('WontCome', <Btn style={style}>{t('WontCome')}</Btn>)}
        </css.wrapper>
    );
}

export default ArrivalConfirmationButtons ;